import "./designer.css";
import Views from "./components/Views";
import ViewThumbnails from "./components/ViewThumbnails";
import Header from "./components/layout/Header";
import Sidebar from "./components/layout/Sidebar";
import Pricing from "./components/layout/Pricing";
import classNames from "classnames";
import ReactSlider from "react-slider";
import Zoom from "./components/layout/Zoom";
import MobileViewThumbnails from "./components/MobileViewThumbnails";
import { useAppDispatch, useAppSelector } from "../hooks/reduxHooks";
import { useEffect } from "react";
import {
  fetchProductCatalogColors,
  fetchProductDetails,
  fetchProductImages,
} from "./store/slices/productSlice";
import { useParams } from "react-router-dom";
import VariantSlider from "./components/layout/VariantSlider";
import {
  generateDesignData,
  redo,
  undo,
} from "../designer/store/slices/viewSlice";

function Designer() {
  const currentStep = useAppSelector((state) => state.steps.step);
  const currentStep_test = useAppSelector((state) => state);
  // console.log("currentStep_test____", currentStep_test);

  const dispatch = useAppDispatch();

  let { productId } = useParams();
  const callFunction = () => {
    dispatch(generateDesignData({}))
      .unwrap()
      .then((data: any) => {
        const modifiedData = removeLineObjectFromAll(data);
        console.log("modifiedData______", modifiedData);
      });
  };
  function removeLineObjectFromAll(jsonData: any) {
    for (const key in jsonData) {
      if (
        jsonData.hasOwnProperty(key) &&
        jsonData[key].json &&
        jsonData[key].json.objects
      ) {
        // Filter out objects with type "line"
        jsonData[key].json.objects = jsonData[key].json.objects.filter(
          (obj: any) => obj.type !== "line"
        );
      }
    }

    // Return the modified JSON
    return jsonData;
  }
  
  useEffect(() => {
    // Clarity is now loaded via script tag in index.html
    
    //  callFunction();
    dispatch(fetchProductImages({ productId: productId }));
    dispatch(fetchProductDetails({ productId: productId }));
    dispatch(fetchProductCatalogColors({ productId: productId }));
  }, []);

  return (
    <>
      {/* <Header /> */}
      <div className="flex gap-8">
        <Sidebar />
        <div
          className={classNames(" lg:w-3/5 max-lg:w-full ", {
            ["pl-[100px]"]: currentStep !== 0,
          })}
        >
          <div className="pt-5 fixed z-10 flex flex-col max-lg:hidden">
            <button
              className="p-1 px-4 bg-white rounded-t-md"
              onClick={() => {
                dispatch(undo());
              }}
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_43891_33476)">
                  <path
                    d="M6.13001 2.09945H17.0626C20.9999 2.09945 24.2045 5.42156 24.2045 9.50661C24.2045 13.5904 20.9999 16.9138 17.0626 16.9138H2.13717C2.08508 16.9128 2.0337 16.9015 1.98595 16.8807C1.93821 16.8598 1.89504 16.8298 1.85891 16.7923C1.82278 16.7547 1.7944 16.7104 1.77539 16.6619C1.75638 16.6134 1.74712 16.5616 1.74812 16.5096C1.74812 16.2872 1.92244 16.1066 2.13717 16.1066H17.0626C20.5717 16.1066 23.4264 13.1458 23.4264 9.50661C23.4264 5.86745 20.5717 2.90534 17.0626 2.90534H6.13001C6.02504 2.90302 5.92526 2.85917 5.85257 2.7834C5.77987 2.70762 5.74019 2.60612 5.74223 2.50113C5.74223 2.27882 5.91654 2.09692 6.13128 2.09692"
                    fill="black"
                  />
                  <path
                    d="M6.76521 11.2041C6.86374 11.2041 6.96352 11.242 7.03931 11.3216C7.19089 11.4795 7.19089 11.7347 7.03931 11.8926L2.58668 16.5094L7.03931 21.1262C7.19089 21.2841 7.19089 21.5393 7.03931 21.6972C7.0039 21.7347 6.96121 21.7645 6.91386 21.7849C6.86651 21.8053 6.8155 21.8158 6.76395 21.8158C6.71239 21.8158 6.66138 21.8053 6.61403 21.7849C6.56668 21.7645 6.524 21.7347 6.48858 21.6972L1.7631 16.7949C1.69026 16.7179 1.64966 16.616 1.64966 16.51C1.64966 16.4041 1.69026 16.3021 1.7631 16.2252L6.48984 11.3216C6.52529 11.2842 6.56799 11.2544 6.61532 11.234C6.66266 11.2135 6.71366 11.2042 6.76521 11.2041Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_43891_33476">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button
              className="p-1 px-4 bg-white rounded-b-md"
              onClick={() => {
                dispatch(redo());
              }}
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_43891_33481)">
                  <path
                    d="M19.8892 22.3628H8.34921C4.19321 22.3628 0.810547 18.8548 0.810547 14.5428C0.810547 10.2321 4.19321 6.72412 8.34921 6.72412H24.1039C24.3305 6.72412 24.5145 6.91479 24.5145 7.15079C24.5145 7.38545 24.3305 7.57745 24.1039 7.57745H8.34921C4.64655 7.57612 1.63321 10.7001 1.63321 14.5415C1.63321 18.3841 4.64655 21.5095 8.35055 21.5095H19.8905C20.1172 21.5095 20.3012 21.7001 20.3012 21.9361C20.3012 22.1708 20.1172 22.3615 19.8905 22.3615"
                    fill="black"
                  />
                  <path
                    d="M19.22 12.752C19.1656 12.7519 19.1118 12.7407 19.0618 12.7192C19.0118 12.6976 18.9668 12.6661 18.9293 12.6266C18.8521 12.5453 18.809 12.4375 18.809 12.3253C18.809 12.2131 18.8521 12.1053 18.9293 12.024L23.6293 7.15063L18.9293 2.27597C18.8521 2.19468 18.809 2.0868 18.809 1.97463C18.809 1.86247 18.8521 1.75459 18.9293 1.6733C18.9667 1.63376 19.0118 1.60226 19.0618 1.58073C19.1117 1.5592 19.1656 1.5481 19.22 1.5481C19.2744 1.5481 19.3283 1.5592 19.3783 1.58073C19.4282 1.60226 19.4733 1.63376 19.5107 1.6733L24.5 6.8493C24.66 7.01597 24.66 7.2853 24.5 7.45197L19.5107 12.6266C19.4733 12.6661 19.4282 12.6976 19.3782 12.7192C19.3283 12.7407 19.2744 12.7519 19.22 12.752Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_43891_33481">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
          <div className="p-3 fixed gap-2 z-10 flex flex-col lg:hidden">
            <button
              onClick={() => {
                dispatch(undo());
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="32"
                  height="32"
                  rx="16"
                  fill="black"
                  fillOpacity="0.32"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.1381 15.5288C13.2529 15.6436 13.3218 15.7963 13.332 15.9583C13.3422 16.1203 13.2929 16.2805 13.1934 16.4088L13.1381 16.4714C13.0233 16.5862 12.8705 16.6552 12.7085 16.6654C12.5465 16.6756 12.3863 16.6263 12.2581 16.5268L12.1954 16.4714L9.52874 13.8048C9.41395 13.69 9.345 13.5372 9.33481 13.3752C9.32462 13.2132 9.3739 13.053 9.4734 12.9248L9.52874 12.8621L12.1954 10.1954C12.3154 10.0759 12.4764 10.0065 12.6457 10.0013C12.815 9.99612 12.9799 10.0556 13.1069 10.1676C13.234 10.2796 13.3136 10.4358 13.3297 10.6044C13.3457 10.773 13.297 10.9414 13.1934 11.0754L13.1381 11.1381L11.6101 12.6668H19.0001C19.9471 12.6667 20.8574 13.033 21.5404 13.689C22.2233 14.345 22.626 15.2399 22.6641 16.1861L22.6667 16.3334C22.6668 17.2804 22.3005 18.1907 21.6445 18.8737C20.9885 19.5567 20.0936 19.9594 19.1474 19.9974L19.0001 20.0001H14.0001C13.8302 19.9999 13.6667 19.9349 13.5432 19.8182C13.4196 19.7016 13.3452 19.5421 13.3353 19.3725C13.3253 19.2029 13.3805 19.0359 13.4896 18.9056C13.5986 18.7752 13.7533 18.6915 13.9221 18.6714L14.0001 18.6668H19.0001C19.6084 18.6677 20.193 18.4309 20.6294 18.007C21.0657 17.5831 21.3192 17.0056 21.3359 16.3975C21.3526 15.7894 21.1311 15.1988 20.7187 14.7516C20.3063 14.3044 19.7355 14.0359 19.1281 14.0034L19.0001 14.0001L11.6087 13.9994L13.1381 15.5288Z"
                  fill="white"
                />
              </svg>
            </button>
            <button
              onClick={() => {
                dispatch(redo());
              }}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="32"
                  height="32"
                  rx="16"
                  fill="black"
                  fillOpacity="0.32"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.2905 16.5283C19.1786 16.6431 19.1114 16.7958 19.1014 16.9579C19.0915 17.1199 19.1396 17.2801 19.2366 17.4084L19.2905 17.471C19.4024 17.5858 19.5514 17.6548 19.7093 17.665C19.8673 17.6752 20.0235 17.6259 20.1485 17.5264L20.2096 17.471L22.8096 14.8041C22.9216 14.6893 22.9888 14.5366 22.9987 14.3745C23.0087 14.2125 22.9606 14.0523 22.8636 13.9241L22.8096 13.8614L20.2096 11.1945C20.0926 11.0749 19.9357 11.0055 19.7706 11.0003C19.6056 10.9951 19.4448 11.0546 19.3209 11.1666C19.197 11.2787 19.1194 11.4349 19.1037 11.6035C19.088 11.7721 19.1355 11.9406 19.2366 12.0746L19.2905 12.1372L20.7803 13.666H13.575C12.6517 13.666 11.7641 14.0323 11.0982 14.6884C10.4323 15.3444 10.0397 16.2393 10.0026 17.1857L10 17.333C9.99993 18.2801 10.3571 19.1905 10.9967 19.8735C11.6363 20.5566 12.5088 20.9593 13.4314 20.9973L13.575 21H18.4501C18.6157 20.9998 18.7751 20.9347 18.8956 20.8181C19.016 20.7014 19.0885 20.542 19.0982 20.3723C19.1079 20.2027 19.0541 20.0357 18.9478 19.9053C18.8415 19.775 18.6906 19.6913 18.5261 19.6712L18.4501 19.6666H13.575C12.9819 19.6674 12.4119 19.4307 11.9865 19.0067C11.561 18.5828 11.3139 18.0052 11.2976 17.397C11.2813 16.7889 11.4972 16.1983 11.8993 15.751C12.3014 15.3038 12.8579 15.0353 13.4502 15.0028L13.575 14.9995L20.7816 14.9988L19.2905 16.5283Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
          <div className="m-auto text-center justify-center w-[100%]">
            <ViewThumbnails></ViewThumbnails>
          </div>
          <div className="view-wrapper">
            <Views></Views>
          </div>

          <div className="right-1 max-lg:hidden">
            <VariantSlider></VariantSlider>
          </div>
          <div className="p-3 fixed right-0 gap-2 z-10 flex flex-col lg:hidden top-[65px]">
            <MobileViewThumbnails></MobileViewThumbnails>
            <Zoom mobileZoom={true}></Zoom>
          </div>

          <div className="flex justify-center items-center gap-5 max-lg:hidden fixed bottom-0 bg-white w-3/5 p-2 text-center">
            <span className="font-bold text-sm">Zoom</span>
            <Zoom></Zoom>
          </div>
        </div>
        <Pricing />
      </div>
    </>
  );
}

export default Designer;
